export const authTokenService = {
    saveToken: (token) => saveToken(token),
    clearToken: () => clearToken(),
    clearSessionState: () => clearSessionState(),
    getToken: () => getToken(),
    getClaims: () => getClaims(),
    isAdmin: () => isAdmin(),
    getAvailableStudies: () => getAvailableStudies(),
    getRolesForStudy: (study) => getRolesForStudy(study),
    setSelectedStudy: (study) => setSelectedStudy(study),
    getSelectedStudy: () => getSelectedStudy(),
    getStudiesAndRolesFromClaims: () => getStudiesAndRolesFromClaims(),
    setSelectedPage: (page) => setSelectedPage(page),
    getSelectedPage: () => getSelectedPage(),
};

/**
 * Saves the auth token locally.
 * @param {string} token - The auth token to be stored.
 */
function saveToken (token) {
    localStorage.setItem('access_token', token);
    getStudiesAndRolesFromClaims();
}

/**
 * Clears the token from local storage.
 */
function clearToken () {
    localStorage.removeItem('access_token');    
}

/**
 * Clears the values stored in the session storage such as: roles,
 * studies and selected role.
 */
function clearSessionState () {
    sessionStorage.clear();
}

/**
 * Gets the token from local storage.
 */
function getToken () {
    return localStorage.getItem('access_token');
}


/**
 * Returns the JWT claims
 */
function getClaims () {
    const token = getToken();
    if (token) {
        return JSON.parse(atob(token.split('.')[1])); // TODO - DD - Store this so we don't have to parse every time...
    }
    return {};
}

/**
 * Returns whether or not the user has the 'Admin' role
 */
function isAdmin () {
    // TODO - DD - look into caching this info
    let claims = getClaims();
    if (claims.role && claims.role.length > 0) {
        return (claims.role.indexOf('Admin') !== -1);
    }
}

/**
 * Gets the roles and studies assigned to the user from the claims in the auth token.
 * The roles and studies are placed in the session storage for access. This means they 
 * will NOT get wiped out if the browser is refreshed.
 * 
 * @returns 
 */
function getStudiesAndRolesFromClaims() {
    let rolesInStudy = {};
    let availableStudies = [];
    const rolesInStudies = getClaims().authorities;
    for(let roleInStudy of rolesInStudies) {
        const roleParts = roleInStudy.split(':');
        const study = roleParts[0];
        const role = roleParts[1];
        if(!rolesInStudy[study]) {
            availableStudies.push(study);
            setSelectedStudy(study);
            let roles = [ role ];
            rolesInStudy[study] = roles;
        } else {
            if(!rolesInStudy[study].includes(role)) {
                rolesInStudy[study].push(role);
            }
        }
    }

    sessionStorage.setItem("studies", JSON.stringify(availableStudies));
    sessionStorage.setItem("roles", JSON.stringify(rolesInStudy));
    return rolesInStudy;
}

/**
 * Returns all assigned roles for the specified study.
 * 
 * @param {*} study the study for which to get the roles
 * @returns list of roles
 */
function getRolesForStudy(study) {
    const rolesForStudy = JSON.parse(sessionStorage.getItem("roles"));
    return rolesForStudy[study];
}

/**
 * Returns all avalaible studies from the session storage.
 * 
 * @returns list of available studies
 */
function getAvailableStudies() {
    return JSON.parse(sessionStorage.getItem("studies"));
}

/**
 * Sets the selected study in the session storage.
 * @param {*} study selected study
 */
function setSelectedStudy (study) {
    sessionStorage.setItem('selectedStudy', study);
}

/**
 * Returns the selected study from the session storage.
 * 
 * @returns the selected study
 */
function getSelectedStudy () {
    return sessionStorage.getItem('selectedStudy');
}

/**
 * Sets the selected page in the session storage.
 * @param {*} page selected page
 */
function setSelectedPage (page) {
    sessionStorage.setItem('selectedPage', page);
}

/**
 * Returns the selected page from the session storage.
 * 
 * @returns the selected page
 */
function getSelectedPage () {
    return sessionStorage.getItem('selectedPage');
}
